<template>
  <div>
    <div style="text-align: right">
      <slot name="btns"></slot>
    </div>

    <el-table :data="data" height="180" class="common-el-table-styles" border style="width: 100%">
      <el-table-column width="width" label="昵称">
        <template slot-scope="{ row }">
          <el-radio class="profile-radio" :value="value" @change="$emit('input', row.profile_id)" :label="row.profile_id">
            {{ row.profile_name }}
          </el-radio>
        </template>
      </el-table-column>

      <el-table-column label="头像" width="100">
        <template slot-scope="{ row }">
          <el-image
            shape="square"
            style="width: 26px; height: 26px"
            :preview-src-list="[row.head_image_url]"
            fit="contain"
            :src="row.head_image_url"
          ></el-image>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="80">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onProfileRowRemove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="pageStates.isADA" style="color: red; font-size: 12px; margin-top: 5px">
      注意：【图片】创意必选头像昵称；【视频】创意请不要选择头像昵称，否则会报错！
    </div>
  </div>
</template>

<script>
import { projectComputedMethods } from '../../../../model/project-mixins.js'
export default {
  props: {
    data: Array,
    value: [String, Number]
  },
  computed: {
    ...projectComputedMethods
  },
  methods: {
    onProfileRowRemove() {}
  }
}
</script>

<style lang="scss" scoped>
</style>
